export var CustomAppModels;
(function (CustomAppModels) {
    class CustomApp {
        constructor(data) {
            this.name = data.name;
            this.codename = data.codename;
            this._raw = data._raw;
            this.source_url = data.source_url;
            this.config = data.config;
        }
    }
    CustomAppModels.CustomApp = CustomApp;
})(CustomAppModels || (CustomAppModels = {}));
//# sourceMappingURL=custom-app.models.js.map